import { CuiHeader, CuiButton, isMobileOrTablet } from 'front-lib'

const Header = ({ restartAction }) => (
  <div style={{ width: '100%' }}>
    <CuiHeader
      showLogo
      endSecondary={
        !isMobileOrTablet() && (
          <CuiButton color="light" fill="solid" onClick={restartAction}>
            Resubscribe Now
          </CuiButton>
        )
      }
    />
  </div>
)

export default Header
